import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MoreVert from '@mui/icons-material/MoreVert';

import { GBENSContext } from '../GBENSContainer';

import Row from './_Row';

const KebabInput = ({
  linkText,
  onClick,
  value = '',
  placeholder = '',
  name,
  screen,
  id,
  consignmentLine,
  consignmentKebab,
  toolTip,
  rowProps,
  disabled,
}) => {
  const { errors, currentConsignmentErrors, currentConsignmentHMRCErrors } = useContext(GBENSContext);

  const _error = consignmentLine
    ? currentConsignmentErrors?.lines?.find?.((l) => l.id === id)
    : consignmentKebab
      ? currentConsignmentErrors?.[id]
      : (errors?.[screen]?.[id] ?? null);

  const _hmrError = consignmentLine ? (currentConsignmentHMRCErrors?.lines?.find?.((l) => l.id === id) ?? null) : null;

  const endAdornment = linkText ? (
    <InputAdornment
      position="end"
      onClick={onClick}
      style={{ paddingRight: 10, justifyContent: 'center', backgroundColor: 'white', paddingLeft: 10 }}
    >
      <p style={{ textDecoration: 'underline', color: '#00857d', fontSize: 15, cursor: 'pointer' }}>{linkText}</p>
    </InputAdornment>
  ) : (
    <InputAdornment position="end">
      <IconButton onClick={onClick} edge="end">
        <MoreVert />
      </IconButton>
    </InputAdornment>
  );

  return (
    <Row
      name={name}
      warning={_error}
      hmrcWarning={_hmrError}
      toolTip={toolTip}
      rowProps={rowProps}
      component={
        <FormControl variant="standard" fullWidth>
          <TextField
            variant="standard"
            fullWidth
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            onClick={onClick}
            slotProps={{
              input: {
                readOnly: true,
                endAdornment: endAdornment,
              },
              inputLabel: {
                shrink: false,
                style: {
                  color: '#00857d',
                  margin: 0,
                  padding: 0,
                  fontSize: 15,
                  fontStyle: 'italic',
                },
              },
            }}
            sx={{
              '& .MuiInput-underline:before': {
                borderBottom: 'none !important', // Ensures underline is removed before focus
              },
              '& .MuiInput-underline:hover:before': {
                borderBottom: 'none !important', // Ensures underline is removed on hover
              },
              '& .MuiInput-underline:after': {
                borderBottom: 'none !important', // Ensures underline is removed after focus
              },
              input: {
                cursor: 'pointer',
              },
            }}
          />
        </FormControl>
      }
    />
  );
};
KebabInput.propTypes = {
  linkText: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.any,
  screen: PropTypes.string,
  consignmentLine: PropTypes.bool,
  consignmentKebab: PropTypes.bool,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default KebabInput;
